import React from 'react';
import './Category.css';

import { Link } from 'react-router-dom';
import { renderIcon } from '../../utils';



const Category = (props) => {

  // Destructuring props
  const { index, category, count, image } = props;

  return (

    <div className={`category-item category-${index}`}>

      <img src={image} alt={category} /> {/* Category Image */}

      <div className="content">

        <div className='icon'>{renderIcon(category)}</div> {/* Display the Activity icon based on title */}

        <div className="text">
          <div className="label">{count} tours available</div> {/* Number of Listings */}
          <Link to={`/Tours?tourType=${encodeURIComponent(category)}`}> {/* Link to Filtered Tours Page */}
            <h3>{category}</h3> {/* Category Name */}
          </Link>
        </div>

      </div>

    </div>

  );
};

export default Category;